(function($){
	"use strict";

	function isDesktop() {
		return window.innerWidth >= 1300 ? true : false;
	}
	function isTablet() {
		return (window.innerWidth < 1300 && window.innerWidth >= 850) ? true : false;
	}
	function isMobile() {
		return window.innerWidth < 850 ? true : false;
	}

	function openTab(tabSlug) {
		var $topProduct = $('#site-main > .container > .product'),
			$topProductTabs = $('#site-main > .container > .product > .woocommerce-tabs');
		$topProductTabs.find('> .woocommerce-Tabs-panel').hide();
		$topProductTabs.find('> .woocommerce-Tabs-panel--'+tabSlug).show();
		$topProductTabs.find('> .tabs li').removeClass('active');
		$topProductTabs.find('> .tabs li#tab-title-'+tabSlug).addClass('active');
	}

	function initExamPrepBookStudyMode() {
		if (!$('body.page-template-page-book-study-mode').length &&
			!$('body.page-template-page-question-tag-mode').length) return;

		$('.show-explanation-btn').on('click', function(e) {
			$(this).hide();
			$(this).parent().parent().find('.explanation').show();
		});

		$('.answer button').on('click', function(e) {
			//console.log(this, $(this).parent('.answers'), $(this).parent('.answers').find('.answer button .icon'));
			$(this).parent().parent().find('.answer button .icon').html('<i class="fas fa-times-circle"></i>');
			$(this).parent().parent().find('.answer button[data-correct] .icon').html('<i class="fas fa-check-circle"></i>');
			$(this).parent().parent().parent().find('.show-explanation-btn').hide();
			$(this).parent().parent().parent().find('.explanation').show();
			if ($(this).attr('data-correct') == 'true') {
				$(this).find('.icon').addClass('correct-answer');
			} else {
				$(this).find('.icon').addClass('incorrect-answer');
			}
		});
	}

	function initFlashCardStudyMode() {
		if (!$('body.page-template-page-flash-card-mode').length) return;

		$(document.body).on('click', '.question .answers button', function(e) {
			e.preventDefault();

			if ($(this).attr('data-correct') == 'true') {
				$('.question .answer-label').html('You chose the correct answer:');
			} else {
				$('.question .answer-label').html('Incorrect. The correct answer was:');
			}

			$('.question').addClass('flipped');
		});
		$(document.body).on('click', '.question .back', function(e) {

			//console.log(e.target);
			if ($(e.target).parents('.back-arrow').length) return;

			e.preventDefault();

			$('.question').removeClass('displayed');

			setTimeout(function(e) {
				pullFlashCard();
				$('.question').addClass('displayed');
			}, 500);

		});
		$(document.body).on('click', '.question .back-arrow', function(e) {
			e.preventDefault();
			$('.question').removeClass('flipped');
		});

		pullFlashCard();
	}

	function pullFlashCard() {
		var question = questions_json.splice(Math.floor(Math.random()*questions_json.length), 1);

		displayFlashCard(question[0]);
	}

	function displayFlashCard(question) {
		var answers_markup = '',
			correct_answer_markup = '',
			explanation_markup = '<div class="answer-explanation"><p>Explanation:</p><div class="explanation-text">'+question.explanation.replace(/(\r\n|\n|\r)/g,"<br />")+'</div></div>';
		for (var i in question.answers) {
			if (i == question.correct_answer) {
				correct_answer_markup = '<div class="correct-answer"><div class="nav-arrow back-arrow"><i class="fas fa-arrow-left"></i><span class="arrow-text"> Back</span></div><div class="nav-arrow next-arrow"><span class="arrow-text">Next </span><i class="fas fa-arrow-right"></i></div><p class="answer-label">Correct Answer:</p><p style="font-size: 1.8rem;color: green;">' + question.answers[i] + '</p></div>';
				answers_markup += '<div class="answer"><button id="answer-'+i+'" name="answer-'+i+'" data-correct="true">'+question.answers[i]+'</button></div>';
			} else
				answers_markup += '<div class="answer"><button id="answer-'+i+'" name="answer-'+i+'">'+question.answers[i]+'</button></div>';
		}

		var question_markup = '<div class="question"><div class="front"><h3 class="query">'+question.query+'</h3><div class="answers">'+answers_markup+'</div></div><div class="back"><div class="back-inner">'+correct_answer_markup+'<hr>'+explanation_markup+'<button id="next-question">Next Question</button></div></div></div>';
		//console.log(question_markup);

		$('.test-questions').empty().append(question_markup);
		setTimeout(function() {
			$('.question').addClass('displayed');

			setTimeout(function() {
				if ($('.flash-cards .question .back-inner').outerHeight() > $('.flash-cards .question').outerHeight()) {
					$('.flash-cards .question').height($('.flash-cards .question .back-inner').outerHeight() + 100);
				}
			}, 500);

		},1);
	}

	function initChapterTestMode() {
		if (!$('body.page-template-page-chapter-test-mode').length) return;

		var correct_count = 0,
			answered_count = 0,
			total_count = $('.test-questions .question').length;


        $('.show-explanation-btn').on('click', function(e) {
            $(this).hide();
            $(this).parent().parent().find('.explanation').show();
        });

		$('.answer button').on('click', function(e) {
			$(this).parent().parent().find('.answer button .icon').html('<i class="fas fa-circle"></i>');
			$(this).find('.icon').html('<i class="fas fa-check-circle"></i>');
			//$(this).attr

			if ($(this).attr('data-correct') == 'true') {
				$(this).parents('.question').attr('data-correct', 'true');
			} else {
				$(this).parents('.question').attr('data-correct', 'false');
			}
		});

		$('#submit-test').on('click', function(e) {
			$('.test-questions .question[data-correct=true]').each(function(e) {
				correct_count++;
				answered_count++;
			});
			$('.test-questions .question[data-correct=false]').each(function(e) {
				answered_count++;
			});

			// display results
			var percent_right = (correct_count / total_count) * 100,
				recommendation_markup = '';
			if (percent_right >= 75) {
				recommendation_markup = '<span style="color: green;">Congratulations, you\'ve correctly answered enough questions from this chapter to pass this section of your exam!  However, we recommend our students consistently shoot for a 90% score before taking the test.</span>';
			} else if (percent_right >= 90) {
				recommendation_markup = '<span style="color: green;">Congratulations, you\'ve correctly answered enough questions from this chapter to pass this section of your exam!  You are ready to ace this chapter.</span>';
			} else {
				recommendation_markup = '<span style="color: red;">You need to score at least 75% to pass this section of your exam.  We recommend you continue to study this chapter until you hit 90%</span><br/><br /><a href="javascript:location.reload();" style="font-size:24px;">Click Here To Try Again</a><br /><br />';
			}
			var results_markup = '<div id="test-results"><p>With '+correct_count+' out of '+total_count+' questions correct, you\'ve scored a <strong>'+percent_right.toFixed(2)+'%</strong></p><p>'+recommendation_markup+'</p></div>';
			$('.entry-content').empty().html(results_markup);
			$('.test-questions .question[data-correct=true], .instruction-wrap').hide();
			$('.test-questions .question .explanation').show();
			$('.answer button').addClass('show-red');
			$('.answer button[data-correct=true]').removeClass('show-red').addClass('show-green');
			$('.chapter-submit').hide();
			$('.chapter-nav').show();
		});
	}

	function initExamSimMode() {
		if (!$('body.page-template-page-exam-sim-mode').length) return;

		var correct_count = 0,
			answered_count = 0,
			total_count = $('.test-questions .question').length;

		var show_answered_qs = true;
		$('#q-showtoggle').on('click', function(e) {
			if (show_answered_qs) {
				console.log('hide qs');
				show_answered_qs = false;
				$('.question[data-correct]').hide();
				$('#q-showtoggle').html('Hiding Completed Questions');
			} else {
				console.log('show qs');
				show_answered_qs = true;
				$('.question[data-correct]').show();
				$('#q-showtoggle').html('Showing Completed Questions');
			}
		});

		$('.show-explanation-btn').on('click', function(e) {
			$(this).hide();
			$(this).parent().parent().find('.explanation').show();
		});

		$('.answer button').on('click', function(e) {
			$(this).parent().parent().find('.answer button .icon').html('<i class="fas fa-circle"></i>');
			$(this).find('.icon').html('<i class="fas fa-check-circle"></i>');
			//$(this).attr

			if ($(this).attr('data-correct') == 'true') {
				$(this).parents('.question').attr('data-correct', 'true');
			} else {
				$(this).parents('.question').attr('data-correct', 'false');
			}

			if (show_answered_qs) {
				console.log('show');
				//$(this).show();
			} else {
				console.log('slide');
				$(this).parent().parent().parent().slideUp();
			}
		});

		$('.question .mark-for-review').on('click', function(e) {
			var $this = $(this);

			if ($this.hasClass('do-review')) {
				//$this.removeClass('do-review').addClass('do-not-review');
				//$this.html('<i class="fas fa-times-circle"></i></span> This question will not be reviewed after the exam.');
			} else {
				$this.removeClass('ask-to-review').removeClass('do-not-review').addClass('do-review');
				$this.html('<i class="fas fa-check-circle"></i></span> This question was postponed but must be answered before submitting the exam.');
				$this.parent().appendTo('.test-questions');
			}
		});

		$('#submit-test').on('click', function(e) {

			var show_exp = $('#show-explanations-chk').val();

			correct_count = 0;
			answered_count = 0;
			$('.test-questions .question[data-correct=true]').each(function(e) {
				correct_count++;
				answered_count++;
			});
			$('.test-questions .question[data-correct=false]').each(function(e) {
				answered_count++;
			});

			if (!window.___admin && answered_count < total_count) {
				var results_markup = '<div id="test-results"><p class="results-text"><span style="color:red">You must answer all questions before submitting your exam.</span></p></div>';
				$('.entry-content').empty().html(results_markup);

				window.scrollTo(0,0);
				return;
			}

			// display results
			var percent_right = (correct_count / total_count) * 100,
				percent_pass = $('#exam-percent-pass').attr('data-percent-val'),
				recommendation_markup = '';
			console.log('p', percent_pass);
			if (percent_right >= percent_pass) {
				tlc_log_action({
					'exam':   user_data.exam,
					'action': 'Passed',
					'module': 'Exam Sim Mode',
					'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
					'url':    window.location.href
				});
				recommendation_markup = '<span style="color: green;">Congratulations, you\'ve correctly answered enough questions to pass your of your exam!  However, we recommend our students consistently shoot for a 90% score before taking the test.</span>';
			} else if (percent_right >= 90) {
				tlc_log_action({
					'exam':   user_data.exam,
					'action': 'Passed',
					'module': 'Exam Sim Mode',
					'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
					'url':    window.location.href
				});
				recommendation_markup = '<span style="color: green;">Congratulations, you\'ve correctly answered enough questions to pass your exam!  You are ready to ace the test.</span>';
			} else {
				tlc_log_action({
					'exam':   user_data.exam,
					'action': 'Failed',
					'module': 'Exam Sim Mode',
					'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
					'url':    window.location.href
				});
				recommendation_markup = '<span style="color: red;">You need to score at least '+percent_pass+'% to pass your exam.  We recommend you continue to study until you hit 90%</span>';
			}
			var results_markup = '<div id="test-results"><p class="results-text">With '+correct_count+' out of '+total_count+' questions correct, you\'ve scored a <strong>'+percent_right.toFixed(2)+'%</strong></p><p>'+recommendation_markup+'</p></div>';
			$('.entry-content').empty().html(results_markup);
			/*
			$('.test-questions .question[data-correct=true], .instruction-wrap').hide();
			$('.test-questions .question .explanation').show();
			 */
			$('.answer button').addClass('show-red');
			$('.answer button[data-correct=true]').removeClass('show-red').addClass('show-green');
			if (show_exp) {
				$('.test-questions .question .explanation').show();
			} else {
				$('.test-questions .question').hide();
			}
			$('.chapter-submit').hide();

			$('.test-questions').addClass('completed');
			window.scrollTo(0,0);

			clearTimeout(exam_timer);
		});

		var time_limit = parseInt($('.timer').attr('data-time-allowed'));
		var exam_timer = setInterval(function(e) {
			time_limit = time_limit - 1;

			// calculate and update timer
			var date = new Date(null);
			date.setSeconds(time_limit); // specify value for SECONDS here
			var result = date.toISOString().substr(11, 8);
			$('.timer').html(result);

			if (time_limit == 0) {
				clearTimeout(exam_timer);

				$('.test-questions .question[data-correct=true]').each(function(e) {
					correct_count++;
				});

				// display results
				var percent_right = (correct_count / total_count) * 100,
					recommendation_markup = '';
				if (percent_right >= 75) {
					tlc_log_action({
						'exam':   user_data.exam,
						'action': 'Passed',
						'module': 'Exam Sim Mode',
						'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
						'url':    window.location.href
					});
					recommendation_markup = '<span style="color: green;">You\'ve run out of time, but you\'ve correctly answered enough questions to pass your of your exam!  However, we recommend our students consistently shoot for a 90% score before taking the test.</span>';
				} else if (percent_right >= 90) {
					tlc_log_action({
						'exam':   user_data.exam,
						'action': 'Passed',
						'module': 'Exam Sim Mode',
						'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
						'url':    window.location.href
					});
					recommendation_markup = '<span style="color: green;">You\'ve run out of time, but you\'ve correctly answered enough questions to pass your exam!  You are ready to ace the test.</span>';
				} else {
					tlc_log_action({
						'exam':   user_data.exam,
						'action': 'Failed',
						'module': 'Exam Sim Mode',
						'data':   'Scored '+percent_right.toFixed(2)+'% ('+correct_count+' / '+total_count+' correct)',
						'url':    window.location.href
					});
					recommendation_markup = '<span style="color: red;">You\'ve run out of time, and need to score at least 75% to pass your exam.  We recommend you continue to until you hit 90%</span>';
				}
				var results_markup = '<div id="test-results"><p class="results-text">With '+correct_count+' out of '+total_count+' questions correct, you\'ve scored a <strong>'+percent_right.toFixed(2)+'%</strong></p><p>'+recommendation_markup+'</p></div>';
				$('.entry-content').empty().html(results_markup);
				$('.test-questions .question[data-correct=true], .instruction-wrap').hide();
				$('.test-questions .question .explanation').show();
				$('.answer button').addClass('show-red');
				$('.answer button[data-correct=true]').removeClass('show-red').addClass('show-green');
				$('.chapter-submit').hide();

				window.scrollTo(0,0);
			}
		}, 1000);
	}

	function initExamPrepPage() {
		//if (!$('body.page-template-page-classroom').length) return;
		if (typeof user_data == 'undefined') return;

		$('#classroom-courses .classroom-link button').on('click', function(e) {
			e.preventDefault();
			//console.log('test');

			if ($(this).parent().attr('data-company-dashboard')) {
				location.href = $(this).parent().attr('data-store-url');
				return;
			}
			if ($(this).parent().attr('data-store-url')) {
				location.href = $(this).parent().attr('data-store-url');
				return;
			}
			if ($(this).parent().attr('data-enrolled') == 'true') {
				if ($(this).parent().attr('data-cont-ed') == 'true') {
					//location.href = '/classroom/continued-education?state='+$(this).parent().attr('data-course-state');
					location.href = '/classroom/continued-education?state='+$(this).parent().attr('data-course-state')+'&cert='+$(this).parent().attr('data-course');
				} else {
					$(this).parent().find('.mode-links')
						.slideDown();
				}
				return;
			}
		});

		if (user_data.programs.al_contractor_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="al_contractor_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.al_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="al_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.al_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="al_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ak_unlimited_commercial_wiring_administrator_2020_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ak_unlimited_commercial_wiring_administrator_2020_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ak_residential_wiring_administrator_2020_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ak_residential_wiring_administrator_2020_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ak_fitness_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ak_fitness_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ak_certificate_of_fitness_journeyman_electrician_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ak_certificate_of_fitness_journeyman_electrician_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ak_certificate_of_fitness_residential_electrician) {
			var $course = $('.classroom-link[data-course="ak_certificate_of_fitness_residential_electrician"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ak_res_fitness_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ak_res_fitness_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ak_res_administrator_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ak_res_administrator_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ak_com_wiring_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ak_com_wiring_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_res_journeyman_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_res_journeyman_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_res_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_res_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_journeyman_2020_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_journeyman_2020_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_master_2020_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_master_2020_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_journeyman_residential_2020_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_journeyman_residential_2020_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_master_residential_2020_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_master_residential_2020_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_2023_residential_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_2023_residential_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_2023_residential_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ar_2023_residential_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.az_c11_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="az_c11_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.az_2017_c11_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="az_2017_c11_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.az_2017_r11_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="az_2017_r11_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.az_2017_cr11_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="az_2017_cr11_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.ca_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ca_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ca_2020_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ca_2020_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ca_2020_general_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ca_2020_general_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.co_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="co_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.co_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="co_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.co_res_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="co_res_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.co_2023_residential_wireman_cert_prep) {
			var $course = $('.classroom-link[data-course="co_2023_residential_wireman_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.co_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="co_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.co_2023_journeyman_wireman_cert_prep) {
			var $course = $('.classroom-link[data-course="co_2023_journeyman_wireman_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ct_journeyperson_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ct_journeyperson_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ct_2017_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ct_2017_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ct_e1_unlimited_electrical_contractor_cert_prep) {
			var $course = $('.classroom-link[data-course="ct_e1_unlimited_electrical_contractor_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.de_2020_journeyperson_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="de_2020_journeyperson_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.de_2020_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="de_2020_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.de_2020_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="de_2020_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.fl_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="fl_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.fl_2017_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="fl_2017_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.fl_2020_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="fl_2020_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ia_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ia_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ia_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ia_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ia_res_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ia_res_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ia_res_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ia_res_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.ia_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ia_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ia_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ia_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ia_2023_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ia_2023_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ia_2023_master_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ia_2023_master_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.id_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="id_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.id_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="id_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.id_2020_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="id_2020_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.id_2020_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="id_2020_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.id_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="id_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.id_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="id_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ks_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ks_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ks_2017_residential_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ks_2017_residential_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ks_2017_journeyman_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ks_2017_journeyman_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ks_2017_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ks_2017_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.ky_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ky_2017_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_2017_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ky_2020_703_journeyman_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_2020_703_journeyman_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ky_2020_701_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_2020_701_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs['703_ky_2023_journeyman_electrician_cert_prep']) {
			var $course = $('.classroom-link[data-course="703_ky_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ky_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ky_2017_prov_journeyman_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_2017_prov_journeyman_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ky_2017_prov_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_2017_prov_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ky_2020_prov_journeyman_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_2020_prov_journeyman_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ky_2020_prov_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_2020_prov_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ky_2023_prov_journeyman_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_2023_prov_journeyman_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ky_2023_prov_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ky_2023_prov_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.ma_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ma_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ma_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ma_2023_master_electrician_cert_prep"]'); /* Exception moves students from old class to new one */
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ma_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ma_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ma_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ma_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.md_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="md_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.md_journeyperson_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="md_journeyperson_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.md_2020_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="md_2020_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.md_2020_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="md_2020_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.me_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="me_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.me_2020_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="me_2020_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.me_2020_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="me_2020_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.me_2020_limited_electrician_house_wiring_cert_prep) {
			var $course = $('.classroom-link[data-course="me_2020_limited_electrician_house_wiring_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.me_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="me_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.me_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="me_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.mi_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mi_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mi_journeyman_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mi_journeyman_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mi_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mi_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mi_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="mi_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mi_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="mi_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.mo_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mo_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mo_prov_2017_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="mo_prov_2017_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mo_prov_2017_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="mo_prov_2017_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mo_w17_journeyman_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mo_w17_journeyman_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mo_w16_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mo_w16_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mo_g17_journeyman_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mo_g17_journeyman_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mo_g16_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mo_g16_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.mn_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="mn_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mn_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="mn_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.mt_journeyman_2020_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mt_journeyman_2020_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mt_master_2020_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mt_master_2020_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mt_residential_2020_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mt_residential_2020_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mt_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mt_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mt_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mt_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mt_res_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="mt_res_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		// Nebraska
		if (user_data.programs.ne_2020_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ne_2020_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ne_2020_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ne_2020_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ne_2020_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ne_2020_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ne_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ne_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ne_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ne_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ne_2023_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ne_2023_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.nm_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="nm_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.nm_2020_residential_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="nm_2020_residential_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.nv_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="nv_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.nv_g16_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="nv_g16_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.nv_g17_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="nv_g17_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.nv_g18_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="nv_g18_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.nv_t16_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="nv_t16_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.nv_t17_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="nv_t17_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.nv_t18_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="nv_t18_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.ok_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ok_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ok_residential_electrical_journeyman) {
			var $course = $('.classroom-link[data-course="ok_residential_electrical_journeyman"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ok_unlimited_electrical_journeyman) {
			var $course = $('.classroom-link[data-course="ok_unlimited_electrical_journeyman"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ok_2020_residential_electrical_contractor_cert_prep) {
			var $course = $('.classroom-link[data-course="ok_2020_residential_electrical_contractor_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ok_2020_limited_electrical_contractor_cert_prep) {
			var $course = $('.classroom-link[data-course="ok_2020_limited_electrical_contractor_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ok_2020_unlimited_electrical_contractor_cert_prep) {
			var $course = $('.classroom-link[data-course="ok_2020_unlimited_electrical_contractor_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ok_2023_unlimited_electrical_journeyman_cert_prep) {
			var $course = $('.classroom-link[data-course="ok_2023_unlimited_electrical_journeyman_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ok_2023_residential_electrical_journeyman_cert_prep) {
			var $course = $('.classroom-link[data-course="ok_2023_residential_electrical_journeyman_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ok_2023_residential_electrical_contractor_cert_prep) {
			var $course = $('.classroom-link[data-course="ok_2023_residential_electrical_contractor_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ok_2023_limited_electrical_contractor_cert_prep) {
			var $course = $('.classroom-link[data-course="ok_2023_limited_electrical_contractor_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ok_2023_unlimited_electrical_contractor_cert_prep) {
			var $course = $('.classroom-link[data-course="ok_2023_unlimited_electrical_contractor_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.sc_2020_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="sc_2020_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.sc_2020_journeyman_electrician_residential_cert_prep) {
			var $course = $('.classroom-link[data-course="sc_2020_journeyman_electrician_residential_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.sc_2020_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="sc_2020_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.sc_2020_master_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="sc_2020_master_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.sd_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="sd_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.sd_2020_531_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="sd_2020_531_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.sd_2020_530_electrical_contractor_cert_prep) {
			var $course = $('.classroom-link[data-course="sd_2020_530_electrical_contractor_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.sd_2020_533_class_b_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="sd_2020_533_class_b_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.sd_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="sd_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.sd_2023_electrical_contractor_cert_prep) {
			var $course = $('.classroom-link[data-course="sd_2023_electrical_contractor_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.sd_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="sd_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.tn_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="tn_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.tn_2017_lle_exam_prep) {
			var $course = $('.classroom-link[data-course="tn_2017_lle_exam_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.tn_metro_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="tn_metro_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.tn_metro_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="tn_metro_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.tx_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="tx_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.tx_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="tx_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.tx_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="tx_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.tx_2023_residential_wireman_cert_prep) {
			var $course = $('.classroom-link[data-course="tx_2023_residential_wireman_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ut_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="ut_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ut_2020_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ut_2020_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ut_2020_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ut_2020_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ut_2020_residential_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ut_2020_residential_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ut_2020_residential_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ut_2020_residential_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ut_2023_residential_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ut_2023_residential_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ut_2023_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ut_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ut_2023_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="ut_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.vt_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="vt_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.vt_2020_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="vt_2020_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.vt_2020_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="vt_2020_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.va_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="va_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.va_master_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="va_master_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.va_2020_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="va_2020_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.va_2020_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="va_2020_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wa_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="wa_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wa_2020_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="wa_2020_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wa_2020_general_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="wa_2020_general_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wa_2020_general_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="wa_2020_general_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wa_2020_general_administrator_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="wa_2020_general_administrator_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wa_2020_residential_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="wa_2020_residential_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wa_2020_residential_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="wa_2020_residential_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wa_2020_residential_administrator_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="wa_2020_residential_administrator_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

		if (user_data.programs.wy_electrical_cert_prep) {
			var $course = $('.classroom-link[data-course="wy_electrical_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wy_385_journeyman_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="wy_385_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wy_701_master_electrician_cert_prep) {
			var $course = $('.classroom-link[data-course="wy_701_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs['385_wy_2023_journeyman_electrician_cert_prep']) {
			var $course = $('.classroom-link[data-course="385_wy_2023_journeyman_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs['701_wy_2023_master_electrician_cert_prep']) {
			var $course = $('.classroom-link[data-course="701_wy_2023_master_electrician_cert_prep"]');
			$course.show();  $('.not-owned-notice').hide();
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}


		/* CONT ED */
		if (user_data.programs.ak_certificate_of_fitness_cont_ed) {
			var $course = $('.classroom-link[data-course="ak_certificate_of_fitness_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ak_administrator_cont_ed) {
			var $course = $('.classroom-link[data-course="ak_administrator_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.al_cont_ed) {
			var $course = $('.classroom-link[data-course="al_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ar_cont_ed) {
			var $course = $('.classroom-link[data-course="ar_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ca_cont_ed) {
			var $course = $('.classroom-link[data-course="ca_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.co_cont_ed) {
			var $course = $('.classroom-link[data-course="co_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.de_cont_ed) {
			var $course = $('.classroom-link[data-course="de_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.id_cont_ed) {
			var $course = $('.classroom-link[data-course="id_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mi_cont_ed) {
			var $course = $('.classroom-link[data-course="mi_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mn_cont_ed) {
			var $course = $('.classroom-link[data-course="mn_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.mt_cont_ed) {
			var $course = $('.classroom-link[data-course="mt_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.or_cont_ed) {
			var $course = $('.classroom-link[data-course="or_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.tx_cont_ed) {
			var $course = $('.classroom-link[data-course="tx_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.ut_cont_ed) {
			var $course = $('.classroom-link[data-course="ut_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.vt_cont_ed) {
			var $course = $('.classroom-link[data-course="vt_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.va_cont_ed) {
			var $course = $('.classroom-link[data-course="va_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wa_cont_ed) {
			var $course = $('.classroom-link[data-course="wa_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wi_cont_ed) {
			var $course = $('.classroom-link[data-course="wi_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.wy_cont_ed) {
			var $course = $('.classroom-link[data-course="wy_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}
		if (user_data.programs.test_cont_ed) {
			var $course = $('.classroom-link[data-course="test_cont_ed"]');
			$course.removeAttr('data-store-url').attr('data-enrolled','true');
			$course.show();  $('.ce-not-owned-notice').hide();
			$course.find('.icon')
				.addClass('enrolled')
				.html('<i class="fas fa-check-circle"></i>');
		}

	}

	function initCompanyDashboardPage() {
		if (!$('body.page-template-page-company-dashboard').length) return;

		if ($('#cont-ed-lessons').length && isDesktop() && typeof StickySidebar != 'undefined')
			var contEdLessonsSidebar = new StickySidebar('#cont-ed-lessons .sticky-container', {topSpacing: 47});

		setTimeout(function() {
			$('#cont-ed-lessons .progress-bar, #student-data .progress-bar').each(function (e) {
				$(this).find('.progress-bar-indicator').width(
					100 * (parseInt($(this).attr('data-completed')) / parseInt($(this).attr('data-required'))) + '%'
				);
			});

			$('.student-progress').each(function (e) {
				$(this).width(
					parseInt($(this).attr('data-progress')) + '%'
				);
			});
		}, 1000);

		$('#back-to-dash, #back-to-dash-2').on('click', function(e) {
			$('#company-intro').show();
			$('#student-data').hide();
			window.scrollTo(0,0);
			currentStudentID = false;
		});

		$('#dashboard-state-selector').change(function(e) {
			location.href = '/classroom/company-dashboard/?state='+$(this).val();
		});

		$('#email-cert').on('click', function(e) {
			e.preventDefault();

			var certUrl = '/email-templates/your-certificate-of-completion/?target_user='+currentStudentID;
			if ($('#email-cert-company').is(":checked") == true)
				certUrl += '&cc_user='+companyId;
			window.open(
				certUrl,
				'_blank' // <- This is what makes it open in a new window.
			);

		});

		var currentStudentID = false;
		$('.available-lessons-box li a, .completed-lessons-box li a, .recommended-lessons-box li a, .unenrolled-lessons-box li a, .overdue-lessons-box li a, .no_due_date-lessons-box li a, .cert-prep-lessons-box li a, .students-due-box a').on('click', function(e) {
			$('#company-intro').hide();
			$('#student-data').show();

			var studentId = $(this).attr('data-student');
			currentStudentID = studentId;
			$('.current-lesson').removeClass('current-lesson');
			$('a[data-student="'+studentId+'"]').parent().addClass('current-lesson');

			var student = companyStudents[studentId];
			//console.log(student);

			regDate = false;
			if (student.user_registered != "0000-00-00 00:00:00") {
				var regDate = new Date(student.user_registered);
				var ampm = 'AM';
				var regHours = regDate.getHours() + 1;
				if (regHours > 12) {
					regHours = regHours - 12;
					ampm = 'PM';
				}
				var regDateStr = (regDate.getMonth() + 1) + '/' + regDate.getDate() + '/' + regDate.getFullYear() + ' at ' + regHours + ':' + ("0" + regDate.getMinutes()).slice(-2) + ' ' + ampm;
				$('#student-joined').html(regDateStr);
				$('.student-joined').show();
			} else {
				$('#student-joined').html('No record.');
				$('.student-joined').hide();
			}

			$('#student-print-cert').hide();
			$('#email-cert-company-wrap').hide();
			$('#cert-already-sent-notice').hide();

			var isFinished = true;
			for (var j in student.progress) {
				var progress = student.progress[j];
				if (!progress.finished)
					isFinished = false;
			}
			if (isFinished && (!certPrintAllowed || certPrintAllowed != 'none')) {
				$('#student-print-cert').show();
				if (certReceiveAllowed == 'both') {
					$('#email-cert-company-wrap').show();
				}
				if (certReceiveAllowed == 'both' || certReceiveAllowed == 'student') {
					$('#email-target-label').html('the student');
				}
				if (certReceiveAllowed == 'company') {
					$('#email-target-label').html('the company');
				}
				if (student.cert_sent)
					$('#cert-already-sent-notice').show();
			}

			$('#student-name').html(student.display_name);
			$('#student-email').html(student.user_email);

			if (student.cert_num) {
				$('#student-certnum').html(student.cert_num);
				$('.student-certnum').show();
			} else
				$('.student-certnum').hide();

			//console.log(student);
			if (typeof student.due_date_formatted != 'undefined' && student.due_date_formatted) {
				if (student.days_until_due > 0) {
					$('#student-due').html(student.due_date_formatted + ' (' + student.days_until_due + ' days until due)');
				} else {
					$('#student-due').html(student.due_date_formatted);
				}
				$('.student-due').show();
			} else
				$('.student-due').hide();

			$('#student-data .my-progress-box .progress-report').remove();

			if (student.enrolled) {
				$('#student-cont-ed-data').show();

				var progressBars = '';

				for (var j in student.progress) {
					var progress = student.progress[j];
					progressBars += '<div class="progress-report"><p>' + progress.label + '</p><div class="progress-bar" data-completed="' + progress.completed + '" data-required="' + progress.required + '"><div class="progress-bar-label">' + progress.completed + ' of ' + progress.required + '</div><div class="progress-bar-indicator"></div></div></div>';
				}

				$('#student-data .my-progress-box').append(progressBars);
				$('#student-data .progress-bar').each(function (e) {
					$(this).find('.progress-bar-indicator').width(
						100 * (parseInt($(this).attr('data-completed')) / parseInt($(this).attr('data-required'))) + '%'
					);
				});

				$('#completed-lessons').empty();
				var lessonCount = 0;
				for (var i in student.lessons) {
					var lesson = student.lessons[i];

					var compDate = new Date(lesson.date_completed);
					var ampm = 'AM';
					var compHours = compDate.getHours() + 1;
					if (compHours > 12) {
						compHours = compHours - 12;
						ampm = 'PM';
					}
					var compDateStr = (compDate.getMonth() + 1) + '/' + compDate.getDate() + '/' + compDate.getFullYear();
					$('#completed-lessons').append('<tr><td><a href="' + lesson.link + '?state=' + curState + '" target="_blank">' + lesson.title + '</a></td><td>' + compDateStr + '</td><td>' + lesson.test_score + '%</td></tr>');
					lessonCount++;
					sorttable.makeSortable(jQuery('.completed-lessons').get(0));
				}
				if (!lessonCount)
					$('#completed-lessons').append('<tr><td colspan="3">This student has not completed any lessons.</td></tr>');

			} else {
				$('#student-cont-ed-data').hide();
			}

			if (student.enrolled_cert_prep) {
				$('#student-cert-prep-data').show();

			} else {
				$('#student-cert-prep-data').hide();
			}

			if (student.actions_log && student.actions_log.length)
				$('#student-log').html(student.actions_log);
			else
				$('#student-log').html("This student has not viewed any material nor taken any actions.");

			if (student.last_action) {
				$('.student-last-action').show();
				$('#student-last-action').html(student.last_action);
			} else {
				$('.student-last-action').hide();
			}

			if ((student.due_soon || student.overdue) && !student.completed) {
				$('#test-results').show();
				if (student.overdue) {
					$('#student-near-due').hide();
					$('#student-overdue').show();
					$('#student-days-overdue').html(-parseInt(student.days_until_due));
				} else {
					$('#student-near-due').show();
					$('#student-overdue').hide();
					$('#student-days-left').html(student.days_until_due);
				}
			} else
				$('#test-results').hide();

			if (!student.cert_prep_log || student.cert_prep_log.length == 0 || student.cert_prep_log == "")
				$('#student-cert-prep-table').html('<tr><td colspan="3">This student has not yet taken any actions.</td></tr>');
			else {
				var _cp_table = '';
				for (var i in student.cert_prep_log) {
					_cp_table += '<tr><td>'+student.cert_prep_log[i][2]+'</td><td>'+student.cert_prep_log[i][3]+'</td><td sorttable_customkey="'+student.cert_prep_log[i][0]+'">'+student.cert_prep_log[i][1]+'</td></tr>';
				}
				$('#student-cert-prep-table').html(_cp_table);
				sorttable.makeSortable(jQuery('.student-cert-prep-log').get(0));
			}

			window.scrollTo(0,0);
		});
	}

	var exam_timer = false,
		timer_complete = false;
	function initContEdMode() {
		if (!$('body.single-lesson').length && !$('body.page-template-page-cont-ed').length) return;

		var _isMobile = false;
		doWindowResize();
		$( window ).on( "resize",  doWindowResize);

		function doWindowResize() {
			var _w = $( window ).width();
			if (_w < 850) {
				if (_isMobile == false)
					$('#lesson-test').insertBefore('#lesson-content');
				_isMobile = true;
			} else {
				if (_isMobile == true)
					$('#lesson-test').insertAfter('#lesson-content');
				_isMobile = false;
			}
		}

		var completed_lesson_count = 0;

		for (var i in user_data.lessons) {
			var lesson = user_data.lessons[i];
			//console.log(i, user_data.lessons[i]);

			if ($('#cont-ed-lessons [data-lesson='+i+']').length) {
				var $lesson = $('#cont-ed-lessons [data-lesson='+i+']').attr('data-completed','true');
				$lesson.find('.icon')
					.addClass('completed')
					.html('<i class="fas fa-check-circle"></i>');
				completed_lesson_count++;
			}
		}

		$('#warning-lessons-completed-count').html(completed_lesson_count);
		if (completed_lesson_count) {
			$('#warning-lessons-completed').show();
		}

		$('#email-cert').on('click', function(e) {
			e.preventDefault();

			var certUrl = '/email-templates/your-certificate-of-completion/?target_user='+$('#email-cert').attr('data-user-id')+'&target_course='+$('#email-cert').attr('data-course');
			window.open(
				certUrl,
				'_blank' // <- This is what makes it open in a new window.
			);

		});

		if ($('#cont-ed-lessons').length && isDesktop() && typeof StickySidebar != 'undefined')
			var contEdLessonsSidebar = new StickySidebar('#cont-ed-lessons .sticky-container', {topSpacing: 47});
		if ($('#lesson-test').length && (isTablet() || isDesktop()) && typeof StickySidebar != 'undefined')
			var contEdTestSidebar = new StickySidebar('#lesson-test .sticky-container', {topSpacing: 47});

		setTimeout(function() {
			$('#cont-ed-lessons .progress-bar').each(function (e) {
				$(this).find('.progress-bar-indicator').width(
					100 * (parseInt($(this).attr('data-completed')) / parseInt($(this).attr('data-required'))) + '%'
				);
			});
		}, 1000);

		// Test stuff
		var currentScore = 0;
		$('#open-test-btn').on('click', function(e) {
			$('#test-closed').hide();
			$('#test-opened').show();
			$('#test-opened .question[data-question-completed="false"]').first().show();
		});

		$('.answer .answer-btn').on('click', function(e) {
			$(this).parent().parent().find('.answer .answer-btn .icon').html('<i class="fas fa-circle"></i>');
			$(this).find('.icon').html('<i class="fas fa-check-circle"></i>');
			//$(this).attr

			if ($(this).attr('data-correct') == 'true') {
				$(this).parents('.question').attr('data-correct', 'true');
				currentScore++;
				$('#test-score').val(currentScore);
			} else {
				$(this).parents('.question').attr('data-correct', 'false');
			}

			$(this).parents('.question').attr('data-question-completed', true);

			var $nextQuestion = $('#test-opened .question[data-question-completed="false"]').first();
			if ($nextQuestion.length) {
				$(this).parents('.question').hide();
				$nextQuestion.show();
			} else {
				//submit
				$('#submit-test').submit();
			}
		});


		//if (typeof test_time_limit_seconds == 'undefined') test_time_limit_seconds = 0;
		if (typeof test_time_limit_seconds != 'undefined') {

			if (test_time_limit_seconds > 0) {
				//var time_limit = parseInt($('.timer').attr('data-time-allowed'));
				var time_limit = lesson_time_remaining;

				function examTimerTick(e) {
					if (time_limit > 0)
						time_limit = time_limit - 1;

					// calculate and update timer
					var date = new Date(null);
					date.setSeconds(time_limit); // specify value for SECONDS here
					var result = date.toISOString().substr(11, 8);
					$('.timer').html(result);

					if (time_limit == 0) {
						timer_complete = true;
						console.log('time complete');
						clearTimeout(exam_timer);

						/*
						tlc_log_action({
							'exam': conted_lesson,
							'action': 'Test timed out',
							'module': conted_course,
							'data': time_limit+' seconds elapsed',
							'url': window.location.href
						});

						 */

						$('.test-timeout-label').empty().html("You've spent the required time for this lesson. Pass the test to complete it.");
						//$('#restart-test-btn').show();
						$('.timer-p').attr('style', 'color: green');
						$('.timer-clock-icon').hide();
						$('.timer-check-icon').show();

						//$('.question').hide();
						//$('#submit-test').hide();

						jQuery.get(location.href+'&test_lesson='+_lesson_post_id+'&activity_inc=0', function(data) {
							console.log('ax', data);
							var is_complete = parseInt(data);
							//if (is_complete)
							//	clearTimeout(activity_timer);
							if (is_complete && _studentPassedTest)
								window.location.reload();
						});
					}

					if (time_limit % 60 == 0) {
						console.log('activity logged');

						var activity_seconds = activity_timer_interval;
						jQuery.get(location.href+'&test_lesson='+_lesson_post_id+'&activity_inc='+time_limit, function(data) {
							console.log('a', data);
							var is_complete = parseInt(data);
							if (is_complete && _studentPassedTest)
								window.location.reload();
						});
					}


				}

				/*
				document.addEventListener("beforeunload", function() {
					jQuery.get(location.href+'&test_lesson='+_lesson_post_id+'&activity_inc='+time_limit, function(data) {});
				});

				 */

				exam_timer = setInterval(examTimerTick, 1000);


				$('#lesson-resume-btn').on('click', function (e) {
					is_inactive = false;
					$('#lesson-timeout-notice').hide();
					startInactivityTimer();
					if (!timer_complete)
						exam_timer = setInterval(examTimerTick, 1000);
				});

				startInactivityTimer();
				//console.log('JJJ', test_time_limit_seconds);
				//startActivityUpdates();


				document.addEventListener("visibilitychange", function() {
					console.log( 'page hidden ' + document.hidden );

					if (document.hidden) {
						clearTimeout(exam_timer);
						//clearTimeout(activity_timer);
						clearTimeout(inactivity_timer);
					} else {
						//startActivityUpdates();
						if (!timer_complete)
							exam_timer = setInterval(examTimerTick, 1000);
						is_inactive = false;
						$('#lesson-timeout-notice').hide();
						startInactivityTimer();
					}

				});
			}

		}


	}



	var activity_timer;
	var activity_timer_interval = 60;
	var activity_timer_elapsed_seconds = 0;
	function startActivityUpdates() {
		clearTimeout(activity_timer);
		activity_timer = setInterval(function (e) {
			console.log('activity logged');

			var activity_seconds = activity_timer_interval;
			jQuery.get('https://thompsonlearningco.com/lesson/nec-2023-article-200-215/?state=AL&cert=al_cont_ed&test_lesson='+_lesson_post_id+'&activity_inc='+activity_seconds, function(data) {
				console.log('a', data);
				var is_complete = parseInt(data);
				if (is_complete)
					window.location.reload();
			});

		}, activity_timer_interval * 1000);
	}
	function stopActivityUpdates() {
		clearTimeout(activity_timer);
	}

	var inactivity_timer,
		mousemoveTimer,
		is_inactive = false;
	function startInactivityTimer() {
		clearTimeout(inactivity_timer);
		is_inactive = true;
		inactivity_timer = setTimeout(function (e) {
			console.log('timeout');
			beginInactivityCountdown();
		}, 300000);
	}

	//if (typeof test_time_limit_seconds == 'undefined') test_time_limit_seconds = 0;
	if (typeof test_time_limit_seconds != 'undefined') {

		if (test_time_limit_seconds > 0) {
			var _student_active = false;
			$(document).on('mousemove', function (e) {
				_student_active = true;
				//console.log('moved');
			});
			$(document).on('keydown', function (e) {
				_student_active = true;
				//console.log('pressed');
			});
			mousemoveTimer = setInterval(function () {
				if (_student_active) {
					//clearTimeout(inactivity_timer);
					startInactivityTimer();
					console.log('active');
				}
				_student_active = false;
			}, 1000);

		}
	}
	function beginInactivityCountdown() {
		if (!$('body.single-lesson').length) return;

		clearTimeout(exam_timer);

		$('#lesson-timeout-notice').show();

		//var in_limit = parseInt($('.inactivity-timer').attr('data-time-allowed'));
		var time_limit = 30;
		var countdown_timer = setInterval(function (e) {
			time_limit = time_limit - 1;

			$('.inactivity-timer').html(time_limit);

			if (time_limit == 0) {
				clearTimeout(countdown_timer);
				//clearTimeout(activity_timer);

				/*
                tlc_log_action({
                    'exam': conted_lesson,
                    'action': 'Test timed out',
                    'module': conted_course,
                    'data': time_limit+' seconds elapsed',
                    'url': window.location.href
                });

                 */

				//$('#test-timeout-label').empty().html("You've run out of time. Restart the lesson to try again.");
				//$('#restart-test-btn').show();
				var activity_seconds = activity_timer_interval;
				jQuery.get('https://thompsonlearningco.com/lesson/nec-2023-article-200-215/?state=AL&cert=al_cont_ed&test_lesson='+_lesson_post_id+'&activity_inc='+activity_seconds, function(data) {
					$('.inactivity-timer').addClass('show-red');
					$('#lesson-idle-message').html("Your session ended due to inactivity.  Reload the page to resume the lesson.");
					$('#lesson-resume-btn').hide();
					$('#lesson-restart-btn').show();
				});
			}
		}, 1000);
	}

	function initCertPrepDashboardPage() {
		if (!$('body.page-template-page-cert-prep-dashboard').length) return;

		if ($('#cont-ed-lessons').length && isDesktop() && typeof StickySidebar != 'undefined')
			var contEdLessonsSidebar = new StickySidebar('#cont-ed-lessons .sticky-container', {topSpacing: 47});


		$('#back-to-dash, #back-to-dash-2').on('click', function(e) {
			$('#company-intro').show();
			$('#student-data').hide();
			window.scrollTo(0,0);
			currentStudentID = false;
			console.log('back');
		});


		var currentStudentID = false;
		$('.available-lessons-box li a, .completed-lessons-box li a, .recommended-lessons-box li a, .unenrolled-lessons-box li a, .overdue-lessons-box li a, .no_due_date-lessons-box li a, .cert-prep-lessons-box li a, .students-due-box a').on('click', function(e) {
			$('#company-intro').hide();
			$('#student-data').show();

			var studentId = $(this).attr('data-student');
			currentStudentID = studentId;
			$('.current-lesson').removeClass('current-lesson');
			$('a[data-student="'+studentId+'"]').parent().addClass('current-lesson');

			var student = companyStudents[studentId];
			//console.log(student);

			regDate = false;
			if (student.user_registered != "0000-00-00 00:00:00") {
				var regDate = new Date(student.user_registered);
				var ampm = 'AM';
				var regHours = regDate.getHours() + 1;
				if (regHours > 12) {
					regHours = regHours - 12;
					ampm = 'PM';
				}
				var regDateStr = (regDate.getMonth() + 1) + '/' + regDate.getDate() + '/' + regDate.getFullYear() + ' at ' + regHours + ':' + ("0" + regDate.getMinutes()).slice(-2) + ' ' + ampm;
				$('#student-joined').html(regDateStr);
				$('.student-joined').show();
			} else {
				$('#student-joined').html('No record.');
				$('.student-joined').hide();
			}




			$('#student-name').html(student.display_name);
			$('#student-email').html(student.user_email);


			$('#student-cert-prep-data').show();


			if (student.actions_log && student.actions_log.length)
				$('#student-log').html(student.actions_log);
			else
				$('#student-log').html("This student has not viewed any material nor taken any actions.");

			if (student.last_action) {
				$('.student-last-action').show();
				$('#student-last-action').html(student.last_action);
			} else {
				$('.student-last-action').hide();
			}


			if (!student.cert_prep_log || student.cert_prep_log.length == 0 || student.cert_prep_log == "")
				$('#student-cert-prep-table').html('<tr><td colspan="2">This student has not yet taken any actions.</td></tr>');
			else {
				var _cp_table = '';
				for (var i in student.cert_prep_log) {
					_cp_table += '<tr><td>'+student.cert_prep_log[i][2]+'</td><td>'+student.cert_prep_log[i][3]+'</td><td sorttable_customkey="'+student.cert_prep_log[i][0]+'">'+student.cert_prep_log[i][1]+'</td></tr>';
				}
				$('#student-cert-prep-table').html(_cp_table);
				sorttable.makeSortable(jQuery('.student-cert-prep-log').get(0));
			}

			window.scrollTo(0,0);
		});
	}

	jQuery(function($) {

		initExamPrepPage();
		initExamPrepBookStudyMode();
		initFlashCardStudyMode();
		initChapterTestMode();
		initExamSimMode();
		initContEdMode();
		initCompanyDashboardPage();
		initCertPrepDashboardPage();

		//$('.description_tab').click();

		$('#site-main > .container > .product > .woocommerce-tabs > ul > li > a').on('click', function() {
			//console.log('r');
			//$('.panel .description_tab a').click();
			setTimeout(function() {
				$('.woocommerce-tabs .woocommerce-tabs .woocommerce-Tabs-panel').hide();
				$('.woocommerce-tabs .woocommerce-tabs .woocommerce-Tabs-panel--description').show();
				$('.woocommerce-tabs .woocommerce-tabs .tabs li').removeClass('active');
				$('.woocommerce-tabs .woocommerce-tabs .tabs li.description_tab').addClass('active');
			},10);
		});

		$('.product-column-teaser-read-more-btn').on('click', function(e) {

			$(this).parents('.product-row').find('.product-row-full-text').slideToggle();
			$(this).addClass('section-open');

		});

		if (!isMobile() && typeof $('#us-states-map').usmap != 'undefined') {

			var activeStateColor = '#3c4489',
				activeStateHover = '#4e57a3';
			$('#us-states-map').usmap({
				stateStyles: {fill: '#ccc', stroke: 'transparent', strokeWidth: 2},
				stateHoverStyles: {fill: '#ccc'},
				click: function(event, data) {
					var state = data.name;
					//console.log(data);

					switch (state) {
						/*
						case 'AL':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-alabama-journeyman-electrical-licence-exam/';
							break;

						 */
						case 'AK':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-alaska-electrical-license-exam/';
							break;
						case 'AR':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-arkansas-journeyman-electrical-certification-exam/';
							break;
						case 'AZ':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-arizona-c-11-commercial-electrical-license-exam/';
							break;
						case 'CA':
							window.location.href = 'https://thompsonlearningco.com/product/california-journeyman-electrician-exam/';
							break;
						case 'CO':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-colorado-journeyman-master-electrician-exam/';
							break;
						case 'CN':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-connecticut-electrician-master-electrician-exam/';
							break;
						case 'CT':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-connecticut-electrician-master-electrician-exam/';
							break;
						case 'FL':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-florida-journeyman-electrical-certification-exam/';
							break;
						case 'IA':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-iowa-electrician-master-electrician-exam/';
							break;
						case 'ID':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-idaho-electrical-license-exam/';
							break;
						case 'KS':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-kansas-journeyman-or-master-electrician-exam-copy/';
							break;
						case 'KY':
							window.location.href = 'https://thompsonlearningco.com/product/pass-the-kentucky-journeyman-or-master-electrician-certification-exam/';
							break;
						case 'ME':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-maine-journeyman-electrical-certification-exam/';
							break;
						case 'MA':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-psi-massachusetts-master-electrician-exam/';
							break;
						case 'MD':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-maryland-electrician-master-electrician-exam-copy/';
							break;
						case 'MI':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-psi-michigan-master-electrician-exam/';
							break;
						case 'MO':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-missouri-journeyman-electrical-certification-exam/';
							break;
						case 'MT':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-psi-montana-master-electrician-exam-incomplete-based-on-2014-nec/';
							break;
						case 'NM':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-psi-new-mexico-master-electrician-exam/';
							break;
						case 'NV':
							window.location.href = 'https://thompsonlearningco.com/product/pass-the-nevada-residential-journeyman-master-electrician-exam/';
							break;
						//case 'NC':
						//	window.location.href = 'https://thompsonlearningco.com/product/pass-your-psi-north-carolina-electrician-exam';
						//	break;
						case 'OK':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-oklahoma-journeyman-or-master-electrician-exam/';
							break;
						case 'SD':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-south-dakota-journeyman-electrician-exam/';
							break;
						case 'TN':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-psi-tennessee-lle-electrician-exam/';
							break;
						case 'TX':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-psi-texas-electrician-exam/';
							break;
						case 'UT':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-psi-utah-electrician-exam/';
							break;
						//case 'VT':
						//	window.location.href = '#';
						//	break;
						case 'VA':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-virginia-journeyman-electrician-exam/';
							break;
						case 'WA':
							window.location.href = 'https://thompsonlearningco.com/product/pass-your-psi-washington-electrician-exam/';
							break;
						case 'WY':
							window.location.href = 'https://thompsonlearningco.com/product/pass-wyoming-electrical-exam/';
							break;
					}
				},
				stateSpecificStyles: {
					'AL': {fill: activeStateColor},
					'AK': {fill: activeStateColor},
					'AR': {fill: activeStateColor},
					'AZ': {fill: activeStateColor},
					'CA': {fill: activeStateColor},
					'CO': {fill: activeStateColor},
					'CN': {fill: activeStateColor},
					'CT': {fill: activeStateColor},
					'FL': {fill: activeStateColor},
					'IA': {fill: activeStateColor},
					'ID': {fill: activeStateColor},
					'KS': {fill: activeStateColor},
					'KY': {fill: activeStateColor},
					'ME': {fill: activeStateColor},
					'MA': {fill: activeStateColor},
					'MD': {fill: activeStateColor},
					'MI': {fill: activeStateColor},
					'MO': {fill: activeStateColor},
					'MT': {fill: activeStateColor},
					'NM': {fill: activeStateColor},
					'NV': {fill: activeStateColor},
					//'NC': {fill: activeStateColor},
					'OK': {fill: activeStateColor},
					'SD': {fill: activeStateColor},
					'TN': {fill: activeStateColor},
					'TX': {fill: activeStateColor},
					'UT': {fill: activeStateColor},
					//'VT': {fill: activeStateColor},
					'VA': {fill: activeStateColor},
					'WA': {fill: activeStateColor},
					'WY': {fill: activeStateColor}
				},
				stateSpecificHoverStyles: {
					'AL': {fill: activeStateHover},
					'AK': {fill: activeStateHover},
					'AR': {fill: activeStateHover},
					'AZ': {fill: activeStateColor},
					'CA': {fill: activeStateHover},
					'CO': {fill: activeStateHover},
					'CN': {fill: activeStateHover},
					'FL': {fill: activeStateHover},
					'IA': {fill: activeStateHover},
					'ID': {fill: activeStateHover},
					'KS': {fill: activeStateHover},
					'KY': {fill: activeStateHover},
					'ME': {fill: activeStateHover},
					'MA': {fill: activeStateHover},
					'MD': {fill: activeStateHover},
					'MI': {fill: activeStateHover},
					'MO': {fill: activeStateHover},
					'MT': {fill: activeStateHover},
					'NM': {fill: activeStateHover},
					'NV': {fill: activeStateHover},
					'NC': {fill: activeStateHover},
					'OK': {fill: activeStateHover},
					'SD': {fill: activeStateHover},
					'TN': {fill: activeStateHover},
					'TX': {fill: activeStateHover},
					'UT': {fill: activeStateHover},
					//'VT': {fill: activeStateColor},
					'VA': {fill: activeStateHover},
					'WA': {fill: activeStateHover},
					'WY': {fill: activeStateHover}
				}
			});

		} else {
			$('#us-states-map').hide();
		}

		$('body').on('added_to_cart', function(){

			console.log('product added');
		});

		$('[data-toggle="tooltip"]').tooltip();

		$('a[href="/our-courses"], a[href="/our-courses/"]').on('click', function(e) {
			e.preventDefault();
			$('.expanded-navigation').addClass('visible');
			setTimeout(function() {
				document.getElementById('all-courses-menu').scrollIntoView();
			},400);
		});
		$('.exam-btn').on('click', function(e) {
			e.preventDefault();
			var $courseLinks = $('#all-courses-menu .course-link a');
			$courseLinks.each(function(i) {
				if ($(this).attr('href').indexOf('#practice-quiz') == -1)
					$(this).attr('href', $(this).attr('href')+'#practice-quiz');
			});
			$('#all-courses .call-to-action').html('Select a program to take a free test or call today for a free consultation: <a href="tel:8666858564">1-866-685-8564</a>');

			$('.expanded-navigation').addClass('visible');
			setTimeout(function() {
				document.getElementById('all-courses-menu').scrollIntoView();
			},400);
		});
		$('.expand-courses-menu a').on('click', function(e) {
			e.preventDefault();
			var $courseLinks = $('#all-courses-menu .course-link a');
			$courseLinks.each(function(i) {
				$(this).attr('href', $(this).attr('href').replace('#practice-quiz',''));
			});
			$('#all-courses .call-to-action').html('Select a program below or give us a call today for a free consultation: <a href="tel:8666858564">1-866-685-8564</a>');
			$('.expanded-navigation').toggleClass('visible');
		});
		$('.expanded-navigation .close').on('click', function(e) {
			e.preventDefault();
			var $courseLinks = $('#all-courses-menu .course-link a');
			$courseLinks.each(function(i) {
				$(this).attr('href', $(this).attr('href').replace('#practice-quiz',''));
			});
			$('#all-courses .call-to-action').html('Select a program below or give us a call today for a free consultation: <a href="tel:8666858564">1-866-685-8564</a>');
			$('.expanded-navigation').removeClass('visible');
		});

		if (window.location.hash) {
			var hashValue = window.location.hash.split('#');
			if (hashValue.length > 1) hashValue = hashValue[1];

			openTab(hashValue);
		}

		$('#clear_shopping_cart').on('click', function(e) {
			$('input').val('');
			e.preventDefault();
		});


		if (typeof user_data != 'undefined' && user_data) {
			$('#site-navbar .classroom-login').html('<a href="/classroom">Online Classroom</a>');

			if (user_data.exam) {
				$('#site-navigation .add-exam a').each(function(e) {
					$(this).attr('href', $(this).attr('href')+'?exam='+user_data.exam);
				});
			}
		}

		var classroomMenuOpen = false;
		$('#desktop-menu-button').on('click', function(e) {
			classroomMenuOpen = !classroomMenuOpen;
			$('#classroom-menu').toggleClass('opened');
			$('#classroom-courses, .classroom-container').toggleClass('opened');
		});

		$('#classroom-menu-cert-prep-courses').on('click', function(e) {
			$('.classroom-menu-level-2').hide();
			$('#classroom-menu-cert-prep-courses-states').show();
			$('.classroom-menu-level-1').addClass('opened-level-2');
		});
		$('#classroom-menu-cont-ed-courses').on('click', function(e) {
			$('.classroom-menu-level-2').hide();
			$('#classroom-menu-cont-ed-courses-states').show();
			$('.classroom-menu-level-1').addClass('opened-level-2');
		});
		$('.classroom-menu-level-2-back-btn').on('click', function(e) {
			$('.classroom-menu-level-1').removeClass('opened-level-2');
		});
		$('#classroom-menu-cert-prep-courses-states .classroom-link button').on('click', function(e) {
			$('.mode-links').hide();
			$(this).next('.mode-links').show();
			$('.classroom-menu-level-1').removeClass('opened-level-2').addClass('opened-level-3');
		});
		console.log('u');
		$('#classroom-menu-cont-ed-courses-states .classroom-link button').on('click', function(e) {
			location.href = '/classroom/continued-education?state='+$(this).parent().attr('data-course-state')+'&cert='+$(this).parent().attr('data-course');
		});
		$('.classroom-menu-level-3-back-btn').on('click', function(e) {
			$('.classroom-menu-level-1').addClass('opened-level-2').removeClass('opened-level-3');
		});

		$('#classroom-menu-company-dashboard').on('click', function(e) {
			if (is_company)
				location.href = '/classroom/company-dashboard/';
			else {
				$('.classroom-menu-level-2').hide();
				$('#classroom-menu-company-dashboard-states').show();
				$('.classroom-menu-level-1').addClass('opened-level-2');
			}

		});

		if(window.location.hash) {
			var hash = window.location.hash.substring(1);
			if (hash == 'our-courses') {
				$('.expand-courses-menu a').click();
			}
		}

		/*
		if(getCookie('firstTimeOnSite2') != 'shown'){
			$("#firstTimeOnSite").delay(1000).fadeIn();
			setCookie('firstTimeOnSite2','shown');
		}

		$('#firstTimeOnSite-close, #firstTimeOnSite').click(function(e) // You are clicking the close button
		{
			$('#firstTimeOnSite').fadeOut(); // Now the pop up is hiden.
		});
		*/
	});

	$('#saveCourseProgress').click(function() {
		console.log('Cookie Set: '+getCookie('tlcUserClassroomProgress'));
		var curUrl = window.location.href.split('#');
		curUrl = curUrl[0];
		var curUrlPlusScroll = curUrl + '#scroll='+$(document).scrollTop();
		setCookie('tlcUserClassroomProgress', curUrlPlusScroll);
	});
	$('#restoreCourseProgress').click(function() {
		var newUrl = getCookie('tlcUserClassroomProgress');
		if (newUrl.split('#scroll=')[0] == window.location.href.split('#scroll=')[0]) {
			console.log('Page Restore: '+getCookie('tlcUserClassroomProgress'));
			window.location.href = newUrl;
			window.location.reload();
		} else {
			console.log('Course Restore: '+getCookie('tlcUserClassroomProgress'));
			window.location.href = newUrl;
		}
	});

	const savedPageScroll = window.location.hash.split('#scroll=');
	if (savedPageScroll.length > 1 && parseInt(savedPageScroll[1]) > 0) {
		console.log('scrolling '+parseInt(savedPageScroll[1]));
		$('html, body').animate({
			scrollTop: parseInt(savedPageScroll[1]) // The target vertical scroll position in pixels
		}, 500);
	}

})(jQuery);


function setCookie(name,value,days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
function eraseCookie(name) {
	document.cookie = name+'=; Max-Age=-99999999;';
}

if (typeof ca_cont_ed_complete != 'undefined' && ca_cont_ed_complete && !getCookie('ca-cont-ed-complete')) {
	jQuery('#cont-ed-complete-popup').show();
	setCookie('ca-cont-ed-complete', 1);
}
jQuery('.popup-close').on('click', function(e) {
	jQuery(this).parent().hide();
});

jQuery( document ).ready(function() {
	jQuery('#payment_method_authorize_net_cim_credit_card').click();
});

function openIframePopup(url) {
	const iframe = document.getElementById('iframePopup_iframe');
	jQuery('#iframePopup_iframe')
		.on('load', () => {
			// Access the iframe's internal document context
			const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

			// Create a new style element
			const styleElement = iframeDoc.createElement('style');
			styleElement.textContent = `
				body.admin-bar { margin-top: 0 !important; }
				#wpadminbar { display: none !important; }
				.zsiq_floatmain { display: none !important; }
			`;

			// Append the custom CSS to the iframe head
			iframeDoc.head.appendChild(styleElement);
		})
		.attr('src', url);
	jQuery('#iframePopup').fadeIn();
}

function isFromSameSite() {
	// 1. Check the document referrer
	const referrer = document.referrer;

	if (referrer) {
		try {
			const referrerUrl = new URL(referrer);
			// Compares the hostnames (e.g., "example.com" vs "example.com")
			if (referrerUrl.hostname === window.location.hostname) {
				return true;
			}
		} catch (e) {
			// Invalid URL format in referrer
		}
	}

	// 2. Check the Navigation Performance API
	const navigationEntry = performance.getEntriesByType('navigation')[0];

	if (navigationEntry) {
		const navType = navigationEntry.type;
		// Returns true if the user reloaded or used back/forward buttons
		if (navType === 'reload' || navType === 'back_forward') {
			return true;
		}
	}

	return false;
}

function copyToClipboard(element) {
	jQuery(document.body)
		.removeAttr('oncopy')
		.removeAttr('oncut')
		.removeAttr('onpaste');
	var $temp = jQuery("<input>");
	jQuery("body").append($temp);
	$temp.val(jQuery(element).text()).select();
	document.execCommand("copy");
	$temp.remove();
	jQuery(document.body)
		.attr('oncopy', 'return false')
		.attr('oncut', 'return false')
		.attr('onpaste', 'return false');
}


function tlc_log_action(postData) {

	if (typeof postData == 'undefined') return;

	postData.url = postData.url.replace('https://thompsonlearningco.com/', '/');

	if (typeof postData.codebook == 'undefined') postData.codebook = '';
	if (typeof postData.chapter == 'undefined') postData.chapter = '';
	if (typeof postData.data == 'undefined') postData.data = '';
	if (typeof postData.exam == 'undefined')
		postData.exam = '';
	else
		postData.exam = postData.exam.toLowerCase();

	jQuery.post(ajax_params.ajax_url, {
		action: 'tlc_log_action',
		user_action: postData.action,
		module: postData.module,
		codebook: postData.codebook,
		chapter: postData.chapter,
		data: postData.data,
		exam: postData.exam,
		url: postData.url
	});
	console.log({
		action: 'tlc_log_action',
		user_action: postData.action,
		module: postData.module,
		codebook: postData.codebook,
		chapter: postData.chapter,
		data: postData.data,
		exam: postData.exam,
		url: postData.url
	});

}

var lastPage = document.referrer;
var internalLink;

// Verify the user came from your own domain
if (lastPage && lastPage.includes(window.location.hostname)) {
	internalLink = true;
	console.log('internal', lastPage);
} else {
	internalLink = false;
	console.log('direct', lastPage);
}